import { apiFetch } from "./api.js";

export type ExecutionLogEntry = {
  id: string;
  tenant_id: string;
  source_type: string;
  status: "success" | "failed";
  started_at: string;
  finished_at: string;
  duration_ms: number;
  row_count: number | null;
  error: string | null;
  details: Record<string, unknown> | null;
  operation_id: string | null;
  node_id: string | null;
  data_provider_id: string | null;
  connector_id: string | null;
  created_at: string;
};

export async function fetchExecutionLog(query: {
  id?: string;
  operation_id?: string;
  node_id?: string;
  data_provider_id?: string;
  connector_id?: string;
  source_type?: string;
  since?: string;
  before?: string;
  limit?: number;
  cursor_finished_at?: string;
  cursor_id?: string;
}): Promise<ExecutionLogEntry[]> {
  const params = new URLSearchParams();
  if (query.id) params.set("id", query.id);
  if (query.operation_id) params.set("operation_id", query.operation_id);
  if (query.node_id) params.set("node_id", query.node_id);
  if (query.data_provider_id) params.set("data_provider_id", query.data_provider_id);
  if (query.connector_id) params.set("connector_id", query.connector_id);
  if (query.source_type) params.set("source_type", query.source_type);
  if (query.since) params.set("since", query.since);
  if (query.before) params.set("before", query.before);
  if (typeof query.limit === "number") params.set("limit", String(query.limit));
  if (query.cursor_finished_at) params.set("cursor_finished_at", query.cursor_finished_at);
  if (query.cursor_id) params.set("cursor_id", query.cursor_id);
  const suffix = params.toString();
  const url = suffix.length > 0 ? `/api/tenant/execution-log?${suffix}` : "/api/tenant/execution-log";
  const data = await apiFetch<{ entries: ExecutionLogEntry[] }>(url);
  return data.entries;
}
